var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("SectionTitle", {
            attrs: { content: "Información de Carta", "has-line": "" }
          }),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-4 col-12 font-weight-bold" },
              [
                _c("ValidationProvider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-date-picker", {
                            attrs: {
                              id: "fundExpirationDate",
                              "class-container": "w-100 mb-3",
                              "custom-error-msg": "El campo es requerido",
                              disabled: _vm.isReadonly,
                              error: errors[0],
                              label: "Fecha de Vencimiento de Fondos:",
                              placeholder: "DD/MM/YYYY"
                            },
                            model: {
                              value: _vm.value.letterInfo.fundExpirationDate,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.value.letterInfo,
                                  "fundExpirationDate",
                                  $$v
                                )
                              },
                              expression: "value.letterInfo.fundExpirationDate"
                            }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-4 col-12 font-weight-bold" },
              [
                _c("ValidationProvider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-date-picker", {
                            attrs: {
                              id: "federalFundDate",
                              "class-container": "w-100 mb-3",
                              "custom-error-msg": "El campo es requerido",
                              disabled: _vm.isReadonly,
                              error: errors[0],
                              label: "Fecha de Fondos Federales:",
                              placeholder: "DD/MM/YYYY"
                            },
                            model: {
                              value: _vm.value.letterInfo.federalFundDate,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.value.letterInfo,
                                  "federalFundDate",
                                  $$v
                                )
                              },
                              expression: "value.letterInfo.federalFundDate"
                            }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-4 col-12 font-weight-bold" },
              [
                _c("ValidationProvider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-date-picker", {
                            attrs: {
                              id: "stateFundDate",
                              "class-container": "w-100 mb-3",
                              "custom-error-msg": "El campo es requerido",
                              disabled: _vm.isReadonly,
                              error: errors[0],
                              label: "Fecha de Fondos Estatales:",
                              placeholder: "DD/MM/YYYY"
                            },
                            model: {
                              value: _vm.value.letterInfo.stateFundDate,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.value.letterInfo,
                                  "stateFundDate",
                                  $$v
                                )
                              },
                              expression: "value.letterInfo.stateFundDate"
                            }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-4 col-12 mb-3 font-weight-bold" },
              [
                _c("ValidationProvider", {
                  attrs: { rules: "required|min_value:1" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-input", {
                            attrs: {
                              id: "additionalRenewalPeriod",
                              "custom-error-msg":
                                "El campo es requerido y debe ser mayor a 0",
                              disabled: _vm.isReadonly,
                              error: errors[0],
                              label: "Período Adicional Renovación:",
                              min: 0,
                              type: "number"
                            },
                            model: {
                              value:
                                _vm.value.letterInfo.additionalRenewalPeriod,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.value.letterInfo,
                                  "additionalRenewalPeriod",
                                  $$v
                                )
                              },
                              expression:
                                "value.letterInfo.additionalRenewalPeriod"
                            }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-4 col-12 mb-3 font-weight-bold" },
              [
                _c("ValidationProvider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-drop-down", {
                            attrs: {
                              id: "renewalTerm",
                              clearable: true,
                              "custom-error-msg": "El campo es requerido",
                              disabled: _vm.isReadonly,
                              error: errors[0],
                              fieldkey: "id",
                              fieldname: "name",
                              label: "Término:",
                              options: _vm.renewalTerms,
                              placeholder: "Seleccione"
                            },
                            model: {
                              value: _vm.value.letterInfo.renewalTerm,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.value.letterInfo,
                                  "renewalTerm",
                                  $$v
                                )
                              },
                              expression: "value.letterInfo.renewalTerm"
                            }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("SectionTitle", {
            attrs: { content: "Firma de Participantes", "has-line": "" }
          }),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              _vm._l(_vm.value.signatures, function(item, index) {
                return _c("participant-signature-row", {
                  key: index,
                  staticClass: "mb-3",
                  attrs: { "is-readonly": _vm.isReadonly, item: item },
                  on: {
                    delete: function($event) {
                      return _vm.removeSignature(index)
                    }
                  }
                })
              }),
              1
            ),
            _vm.isFormVisible
              ? _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("add-participant-signature", {
                      on: {
                        add: _vm.addSignature,
                        cancel: _vm.toggleSignatureForm
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            !_vm.isFormVisible && !_vm.isReadonly
              ? _c(
                  "div",
                  { staticClass: "col-12 d-flex justify-content-end" },
                  [
                    _c("action-button", {
                      staticClass: "mr-2 px-3",
                      attrs: {
                        i: "fas fa-file-plus",
                        text: "Añadir",
                        variant: "success"
                      },
                      on: { click: _vm.toggleSignatureForm }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      !_vm.isReadonly || _vm.isViewModeAward
        ? _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("SectionTitle", {
                attrs: { content: "Documentos", "has-line": "" }
              }),
              _c("add-document", {
                attrs: {
                  documents: _vm.value.documents,
                  "read-only": _vm.isReadonly
                },
                on: {
                  "on-add-document": _vm.addDocumentHandler,
                  "on-remove-document": _vm.removeDocumentHandler
                }
              }),
              _vm.alertMissingDocument
                ? _c("error", {
                    staticClass: "mt-2",
                    attrs: {
                      message: "Al menos 1 documento es requerido",
                      variant: "no-border"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }